import { HttpErrorResponse } from '@angular/common/http';
import { Action } from '@ngrx/store';
import { ProjectRequest } from '@services/associations/model/projectRequest';
import { ProjectResponse } from '@services/associations/model/projectResponse';
import { ProjectSearchRequest } from '@services/associations/model/projectSearchRequest';
import { PaginationModel } from '@shared/models/pagination.model';
import {PageResponseProjectResponse} from "@services/associations/model/pageResponseProjectResponse";

export enum ProjectsActionTypes {
  LoadProjects = '[Projects] Load Projects',
  LoadProjectsSuccess = '[Projects] Load Projects Success',
  LoadProjectsFailure = '[Projects] Load Projects Failure',
  AddProjects = '[Projects] Add Projects',
  AddProjectsSuccess = '[Projects] Add Projects Success',
  AddProjectsFailure = '[Projects] Add Projects Failure',
  EditProjects = '[Projects] Edit Projects',
  EditProjectsSuccess = '[Projects] Edit Projects Success',
  EditProjectsFailure = '[Projects] Edit Projects Failure',
  DeleteProjects = '[Projects] Delete Projects',
  DeleteProjectsSuccess = '[Projects] Delete Projects Success',
  DeleteProjectsFailure = '[Projects] Delete Projects Failure',
  ChangePage = '[Projects] Change Page',
  SetInitialPagination = '[Projects] Set Initial Pagination',
  SetFilter = '[Projects] Set Filter',
  ClearFilter = '[Projects] Clear Filter',
  SetInitialState = '[Projects] Set Initial State',
}

/** Load Projects */
export class LoadProjects implements Action {
  readonly type = ProjectsActionTypes.LoadProjects;
  constructor(public payload?: {dontShowLoading: boolean}) {}
}

export class LoadProjectsSuccess implements Action {
  readonly type = ProjectsActionTypes.LoadProjectsSuccess;
  constructor(public payload: PageResponseProjectResponse) { }
}

export class LoadProjectsFailure implements Action {
  readonly type = ProjectsActionTypes.LoadProjectsFailure;
  constructor(public payload: HttpErrorResponse) { }
}

/** Add Projects */
export class AddProjects implements Action {
  readonly type = ProjectsActionTypes.AddProjects;
  constructor(public payload: ProjectRequest) {}
}

export class AddProjectsSuccess implements Action {
  readonly type = ProjectsActionTypes.AddProjectsSuccess;
  constructor(public payload: ProjectResponse, public isSocket?: boolean) { }
}

export class AddProjectsFailure implements Action {
  readonly type = ProjectsActionTypes.AddProjectsFailure;
  constructor(public payload: HttpErrorResponse) { }
}

/** Edit Projects */
export class EditProjects implements Action {
  readonly type = ProjectsActionTypes.EditProjects;
  constructor(public payload: {projectId: string, request: ProjectRequest}) {}
}

export class EditProjectsSuccess implements Action {
  readonly type = ProjectsActionTypes.EditProjectsSuccess;
  constructor(public payload: ProjectResponse, public isSocket?: boolean) { }
}

export class EditProjectsFailure implements Action {
  readonly type = ProjectsActionTypes.EditProjectsFailure;
  constructor(public payload: HttpErrorResponse) { }
}

/** Delete Projects */
export class DeleteProjects implements Action {
  readonly type = ProjectsActionTypes.DeleteProjects;
  constructor(public payload: string) {}
}

export class DeleteProjectsSuccess implements Action {
  readonly type = ProjectsActionTypes.DeleteProjectsSuccess;
  constructor(public payload: void) { }
}

export class DeleteProjectsFailure implements Action {
  readonly type = ProjectsActionTypes.DeleteProjectsFailure;
  constructor(public payload: HttpErrorResponse) { }
}

/** Change Page */
export class ChangePage implements Action {
  readonly type = ProjectsActionTypes.ChangePage;
  constructor(public payload: PaginationModel) { }
}

/** Set Initial Pagination */
export class SetInitialPagination implements Action {
  readonly type = ProjectsActionTypes.SetInitialPagination;
}

/** Set Filter */
export class SetFilter implements Action {
  readonly type = ProjectsActionTypes.SetFilter;
  constructor(public payload: ProjectSearchRequest) { }
}

/** Clear Filter */
export class ClearFilter implements Action {
  readonly type = ProjectsActionTypes.ClearFilter;
}

/** Set Initial State */
export class SetInitialState implements Action {
  readonly type = ProjectsActionTypes.SetInitialState;
}

export type ProjectsActions =
  | LoadProjects
  | LoadProjectsSuccess
  | LoadProjectsFailure
  | AddProjects
  | AddProjectsSuccess
  | AddProjectsFailure
  | EditProjects
  | EditProjectsSuccess
  | EditProjectsFailure
  | DeleteProjects
  | DeleteProjectsSuccess
  | DeleteProjectsFailure
  | ChangePage
  | SetInitialPagination
  | SetFilter
  | ClearFilter
  | SetInitialState
  ;

